// COMPONENTS
import DropdownButton from "../../../../buttons/dropdown.button";

const DEFAULT_OPTIONS = [
  { label: "10", value: 10 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "75", value: 75 },
  { label: "100", value: 100 },
];

const DEFAULT_CLASSNAMES = {
  option:
    "shadow shadow-black font-ubuntuRegular text-black rounded-sm hover:bg-primary flex flex-row justify-between items-center px-2 py-1",
  label: "",
  selected: "bg-secondary text-white",
};

const LimitDropdown = ({
  limit = 100,
  handleClick = () => {},
  options = DEFAULT_OPTIONS,
  classNames = DEFAULT_CLASSNAMES,
}) => {
  return (
    <DropdownButton
      classNames={classNames?.dropdownButton}
      label="Limit"
      value={limit}
    >
      {options?.map((option, index) => (
        <div
          onClick={handleClick}
          data-value={option?.value}
          key={option?.id || index}
          className={`${classNames?.option || DEFAULT_CLASSNAMES.option} ${
            limit === option?.value
              ? classNames?.selected || DEFAULT_CLASSNAMES.selected
              : "bg-slate-50"
          }`}
        >
          <div
            data-value={option?.value}
            className={classNames?.label || DEFAULT_CLASSNAMES.label}
          >
            {option?.label}
          </div>
        </div>
      ))}
    </DropdownButton>
  );
};

export default LimitDropdown;
